var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcErroroutlined16Px = function SvgIcErroroutlined16Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.434 13H2.566a.566.566 0 0 1-.5-.263.416.416 0 0 1 0-.451L7.5 3.264A.566.566 0 0 1 8 3c.22 0 .402.101.5.264l5.434 9.021a.416.416 0 0 1-.001.452.566.566 0 0 1-.5.263Zm1.356-1.23c.598.992-.154 2.23-1.356 2.23H2.566c-1.203 0-1.955-1.238-1.357-2.23l5.433-9.022c.601-.997 2.113-.997 2.714 0l5.433 9.022ZM8 5.25a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 8 5.25ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgIcErroroutlined16Px;